import { formatCurrency } from '@/Utils/currency'
import { formatDate } from '@/Utils/date'
import { formatQuantity } from '@/Utils/formatQuantity'
import '@babel/polyfill'
import { vMaska } from 'maska'
import 'mutationobserver-shim'
import Raphael from 'raphael/raphael'
import Vue from 'vue'
import Multiselect from 'vue-multiselect'
import vSelect from 'vue-select'
import VueSignature from 'vue-signature-pad'
import App from './App.vue'
import i18n from './i18n'
import './plugins'
import './registerServiceWorker'
import router from './router'
import store from './store'
import '@/mixins/DocumentsValidator.js'

Vue.prototype.$currency = formatCurrency
Vue.prototype.$formatDate = formatDate
Vue.prototype.$quantity = formatQuantity

Vue.filter('currency', formatCurrency)
Vue.filter('formatDate', formatDate)
Vue.filter('quantity', formatQuantity)

Vue.directive('maska', vMaska)

Vue.component('VSelect', vSelect)
Vue.component('VueMultiselect', Multiselect)

Vue.use(VueSignature)

global.Raphael = Raphael
Vue.config.productionTip = false

export const EventBus = new Vue()

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
